import downTriangle from '../assets/down-triangle.svg';
import { STANDARD_COLLECTION, PARTNER_COLLECTION } from '../utils/Constants';

export const BaseCollectionTypeSelector = function ({ value, onChange }) {
  return (
    <div className="base-selector" cy="type-selector">
      <select
        value={value}
        onChange={(ev) => onChange({ key: 'type', value: ev.target.value })}
        className='type-selector'
      >
        <option value={STANDARD_COLLECTION}>Standard Collection</option>
        <option value={PARTNER_COLLECTION}>Partner Collection</option>
      </select>
      <img src={downTriangle} alt="" />
    </div>
  );
};
